// promotion.type is free text with no lookup table, so these are the only values the promotion validators accept.
export var PromotionType;
(function (PromotionType) {
    PromotionType["PRODUCT"] = "product";
    PromotionType["PERCENTAGE_MATCH"] = "percentage";
})(PromotionType || (PromotionType = {}));
//# sourceMappingURL=promotion-type.js.map